export const siteConfig = {
  brand: {
    name: "增长深度 GrowDeep",
    chineseName: "增长深度",
    englishName: "GrowDeep",
    logo: "/assets/growdeep-logo.png",
    siteUrl: "https://growdeep.cn",
    description:
      "增长深度 GrowDeep 是企业品牌增长与产品出海增长服务商，帮助企业以品牌、网站、内容、搜索、数据与运营建立长期增长能力。",
  },
  contact: {
    phone: {
      display: "15167530059",
      international: "+86-151-6753-0059",
    },
    email: "we0Core@wegc.cn",
    wechat: "扫码添加微信",
    address: "深圳市南山区粤海街道",
    city: "深圳市",
    region: "广东省",
    businessHours: "周一至周五 10:30-18:30",
    responseTime: "通常在 24 小时内回复",
    qrCode: {
      src: "/assets/contact.png",
      alt: "GrowDeep 微信二维码",
      label: "微信咨询",
      description: "扫码添加微信",
    },
  },
  chat: {
    title: "在线咨询",
    serviceName: "增长顾问",
    introduction:
      "增长深度为企业提供品牌增长与产品出海服务，覆盖品牌、官网、内容、搜索与持续运营。",
    placeholder: "请输入想咨询的业务问题",
    faqs: [
      {
        question: "增长深度可以帮我们做什么？",
        answer:
          "我们围绕品牌定位、产品表达、官网或独立站、内容建设、SEO / GEO、线索承接和持续运营，帮助企业获得更多曝光、信任与客户线索。",
      },
      {
        question: "我们适合做品牌增长还是产品出海？",
        answer:
          "面向国内市场、需要改善品牌表达和线上获客的企业，适合品牌增长；制造、外贸及出海品牌若希望获得海外客户与询盘，适合从产品出海增长路径开始评估。",
      },
      {
        question: "初步诊断收费吗？",
        answer:
          "初步增长诊断不收费，用于了解企业现状、目标市场和关键问题，判断后续适合的合作路径；如需要更深入的增长诊断，可再确认具体范围。",
      },
      {
        question: "能同时做官网、独立站和 SEO/GEO 吗？",
        answer:
          "可以。官网或独立站承载产品、内容、案例和咨询入口，SEO / GEO 则持续提升传统搜索和 AI 搜索中的曝光，两者可按企业现状组合推进。",
      },
      {
        question: "合作流程是怎样的？",
        answer:
          "我们会依次完成业务沟通、现状诊断、方案共识、启动建设、验证上线和周期运营，并在关键节点与您确认目标、范围、交付物和节奏。",
      },
      {
        question: "服务周期和报价如何确认？",
        answer:
          "服务周期、交付范围和正式报价会在方案共识后结合实际需求确认，并以项目报价单和双方签署合同为准。",
      },
    ],
  },
} as const;
